// src/pages/TermsPage.jsx
import React from "react";

const LAST_UPDATED = "2026-01-22";

export default function TermsPage() {
  return (
    <div className="space-y-10">
      <section className="rounded-3xl border border-white/10 bg-white/5 p-10">
        <p className="text-sm font-semibold text-cyan-300/90 text-center">
          Terms of Service
        </p>

        <h2 className="mt-3 text-center text-3xl font-semibold tracking-tight text-white">
          Service terms
        </h2>

        <p className="mt-4 mx-auto max-w-3xl text-center text-base leading-7 text-white/75">
          These Terms govern your use of StarEpoch Labs products and services. By accessing or
          using the Service, you agree to these Terms. (Last updated: <b>{LAST_UPDATED}</b>)
        </p>

        <div className="mt-8 mx-auto grid max-w-3xl gap-6">
          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold text-white">Use of the Service</div>
            <div className="mt-3 text-sm leading-relaxed text-white/70">
              You agree to use the Service in accordance with applicable laws and these Terms.
              You must not misuse, disrupt, or attempt to gain unauthorized access to the Service,
              systems, or networks.
            </div>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold text-white">Accounts & access</div>
            <div className="mt-3 text-sm leading-relaxed text-white/70">
              If the Service requires an account, you are responsible for maintaining the confidentiality
              of your account and for activities that occur under your account. Please notify us promptly
              if you suspect unauthorized access.
            </div>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold text-white">Subscriptions & billing</div>
            <div className="mt-3 text-sm leading-relaxed text-white/70">
              If you purchase a subscription through the App Store, Apple manages billing, renewals, and
              subscription changes. Refunds are subject to Apple’s policies and processes.
            </div>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold text-white">Changes and availability</div>
            <div className="mt-3 text-sm leading-relaxed text-white/70">
              We may update, modify, or discontinue features of the Service from time to time, including
              for security, compliance, and performance reasons. We do not guarantee uninterrupted or
              error-free availability.
            </div>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold text-white">Disclaimer</div>
            <div className="mt-3 text-sm leading-relaxed text-white/70">
              The Service is provided “as is” and “as available” to the maximum extent permitted by law.
              StarEpoch Labs disclaims all warranties of any kind, whether express or implied, including
              implied warranties of merchantability, fitness for a particular purpose, and non-infringement.
            </div>
          </div>

          <div className="rounded-2xl border border-white/10 bg-white/5 p-7">
            <div className="text-sm font-semibold text-white">Limitation of liability</div>
            <div className="mt-3 text-sm leading-relaxed text-white/70">
              To the maximum extent permitted by law, StarEpoch Labs will not be liable for any indirect,
              incidental, special, consequential, or punitive damages, or any loss of profits or revenues,
              arising out of or related to your use of the Service.
            </div>
          </div>
        </div>

        <div className="mt-6 text-xs text-white/50">
          Note: These Terms are intended to be clear and readable. They may be updated as the Service evolves.
        </div>
      </section>
    </div>
  );
}
